import React, { useEffect } from "react";
import FileListings from "./FileListings";
import AllFiles from "./AllFiles";
import { getTeamFilesListbyid } from "../../../../../redux/team/action";
import { useDispatch, useSelector } from "react-redux";

export default function AllFileListHandleHere({
  selectedOptionid,
  debouncedSearchtext,
  foldervalues,
  displayFileListings,
}) {
  const dispatch = useDispatch();
  const allfilesfolderlist = useSelector(
    ({ team: { getteamfilelistbyid } }) => getteamfilelistbyid,
  );

  useEffect(() => {
    dispatch(
      getTeamFilesListbyid(
        foldervalues?.id,
        selectedOptionid,
        debouncedSearchtext,
      ),
    );
  }, [debouncedSearchtext, selectedOptionid]);

  return (
    <>
      {displayFileListings == true && (
        <FileListings foldervalues={allfilesfolderlist} />
      )}
      {displayFileListings != true && (
        <AllFiles foldervalues={allfilesfolderlist} />
      )}
    </>
  );
}
